import styled, {css} from 'styled-components';
import colors from '@monorepo-zazuu/shared/constants/colors';
import AppointmentStatusEnum from '../../../utils/enums/AppointmentStatusEnum';

export const Content = styled.div`
  text-align: center;
  justify-content: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

export const Card = styled.button<{$blocked?: boolean}>`
  background-color: ${colors.secondary.default};
  border-radius: 8px;
  margin-top: 16px;
  -webkit-box-shadow: 0px 0px 14px 1px rgba(92, 92, 92, 0.4);
  -moz-box-shadow: 0px 0px 14px 1px rgba(92, 92, 92, 0.4);
  box-shadow: 0px 0px 14px 1px rgba(92, 92, 92, 0.4);
  ${props => props.$blocked && css`
    opacity: 0.8;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  `}
`;

export const CardHeader = styled.div<{selected: boolean; status: number; $blocked?: boolean}>`
  display: flex;
  flex-direction: row;
  padding: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${props => props.selected ? colors.secondary.default : colors.gray.dark02};
  ${props => props.status === AppointmentStatusEnum['Aguardando pagamento'] && css`
    background-color: ${colors.suport.warning};
  `}
  ${props => props.$blocked && css`
    background-color: ${colors.gray.dark02};
  `}
`;

export const StatusBadge = styled.span<{$color: string; $textColor: string}>`
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  border-radius: 10rem;
  background-color: ${props => props.$color};
  color: ${props => props.$textColor};
  font-family: 'Manrope', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
`;

export const CardContent = styled.div<{selected: boolean}>`
  background-color: ${colors.gray.white};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  ${props => props.selected && css`
    border: 2px solid ${colors.secondary.default};
  `}
`;

export const CardAddress = styled.div`
  padding: 8px;
`;

export const Button = styled.button`
  margin-left: auto;
`;

export const CollapseContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 8px 8px 8px;
`;
